import TimelineContainer from "./ContainerComponent/TimelineContainer";
import SectionTitle from "../Common/SectionTitle";
import ResumesData from "../../Data/ResumesData";

const Resume = () => {
    return (
        <>
            <SectionTitle SectionName="Experience" />
            <div>
                {ResumesData.map((resume) => (
                    <TimelineContainer key={resume.key} Resume={resume} />
                ))}
            </div>
        </>
    );
};

export default Resume;
